import { createReducer } from "@reduxjs/toolkit";
import { studentRetrieveTrainingItemDetails } from "./retrieve-training-item-details";
import type { TrainingItemDetailsVM } from "@shared-kernel/application/ports/student/student-repository";
import type { RetrievalState } from "@redux/state/shared-types";

const initialState: RetrievalState<TrainingItemDetailsVM | null> = { fetching: "pending", data: null };

export const studentRetrieveTrainingItemDetailsReducer = createReducer<RetrievalState<TrainingItemDetailsVM | null>>(
  initialState,
  builder => {
    builder.addCase(studentRetrieveTrainingItemDetails.fulfilled, (state, { payload }) => {
      return {
        ...state,
        data: payload,
        fetching: "success",
      };
    });
    builder.addCase(studentRetrieveTrainingItemDetails.pending, state => {
      return {
        ...state,
        fetching: "pending",
      };
    });
    builder.addCase(studentRetrieveTrainingItemDetails.rejected, state => {
      return {
        ...state,
        fetching: "failed",
      };
    });
  },
);
